import {
  IoCodeWorking,
  IoLogoGithub,
  IoLogoYoutube,
  IoLogoInstagram,
  IoLogoLinkedin,
  IoLogoWhatsapp,
} from "react-icons/io5";
import attendo from "./images/Attendo.png";
import player from "./images/player.png";
import tindog from "./images/tindog.png";
import mascot from "./images/mascot.png";
import textutils from "./images/textutils.png";
import mynotes from "./images/mynotes.png";

export const Experience = [
  {
    id: 1,
    date: "present",
    iconsSrc: <IoCodeWorking />,
    title: "Final Year Under Graduation",
    location: "Kolhapur, Maharashtra",
    description:
      "Pursuing B.Tech in Computer Science and Engineering at Kolhapur Institute of Technology (Autonomous) ",
  },
  {
    id: 2,
    date: "2022 - 2023",
    iconsSrc: <IoCodeWorking />,
    title: "Intern",
    location: "Kolhapur, Maharashtra",
    description:
      "Fullstack Web Developer Intern at Mascot Software Technology Pvt. Ltd",
  },
  {
    id: 3,
    date: "2017 - 2019",
    iconsSrc: <IoCodeWorking />,
    title: "Student",
    location: "Hyderabad, Telangana",
    description:
      "Pursued Intermediate education in CBSE Board at Narayana IIT Academy, Hyderabad ",
  },
  {
    id: 4,
    date: "2015 - 2016",
    iconsSrc: <IoCodeWorking />,
    title: "Student",
    location: "Latur, Maharashtra",
    description:
      "Pursued SSC Education at Shivaji M.V. Latur ",
  }
 
  // {
  //   id: 5,
  //   date: "2010 - 2011",
  //   iconsSrc: <IoCodeWorking />,
  //   title: "Creative Director",
  //   location: "Doha, Qatar",
  //   description:
  //     "Creative Direction, User Experience, Visual Design, Project Management, Team Leading",
  // },
];

export const Projects = [
  {
    id: 1,
    name: "Attendo",
    imageSrc: attendo,
    techs: "Google FireBase ML Kit, Android, Java",
    github: "https://github.com/KB-2000/ATTENDO",
  },
  {
    id: 2,
    name: "Gaana ",
    imageSrc: player,
    techs: "HTML,CSS,JavaScript",
    github: "https://kb-2000.github.io/Music-Player/",
  },
  {
    id: 3,
    name: "Tindog",
    imageSrc: tindog,
    techs: "HTML, CSS, BootStrap, JavaScript",
    github: "https://kb-2000.github.io/Tin-Dog/",
  },
  {
    id: 4,
    name: "Authentication System ",
    imageSrc: mascot,
    techs: "ReactJs, NodeJs, MongoDB",
    github: "https://github.com/KB-2000/Authentication",
  },
  {
    id: 5,
    name: "Text Utils",
    imageSrc: textutils,
    techs: "React Js, BootStrap",
    github: "https://github.com/KB-2000/Text-Utils",
  },
  {
    id: 6,
    name: "My Notes",
    imageSrc: mynotes,
    techs: "BootStrap, PHP",
    github: "https://github.com/KB-2000/My-Notes",
  },
];

export const SocialLinks = [
  {
    id: 1,
    iconSrc: <IoLogoGithub className="text-textBase text-3xl cursor-pointer" />,
    name: "GitHub",
    link: "https://github.com/KB-2000",
  },
  {
    id: 1,
    iconSrc: <IoLogoYoutube className="text-red-500 text-3xl cursor-pointer" />,
    name: "YouTube",
    link: "https://www.youtube.com/@gamesterkb8839",
  },
  {
    id: 1,
    iconSrc: (
      <IoLogoInstagram className="text-pink-500 text-3xl cursor-pointer" />
    ),
    name: "Instagram",
    link: "https://instagram.com/kb_d_attaguy?igshid=YmMyMTA2M2Y=",
  },
  {
    id: 1,
    iconSrc: (
      <IoLogoLinkedin className="text-blue-800 text-3xl cursor-pointer" />
    ),
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/kaushik-bansode-16054a243/",
  },
  {
    id: 1,
    iconSrc: (
      <IoLogoWhatsapp className="text-green-500 text-3xl cursor-pointer" />
    ),
    name: "Whatsapp",
    link: " https://wa.me/+918080455803?text=Hello there 👋!",
  },
];
